<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Filter Options</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content class="mat-typography" fxFlex>
    <form>
      <app-options-card title="Filter Fax Numbers" [options]="faxNumbers" [collapsed]="false"
                        [(checkedOptions)]="checkedFaxNumbers" [showSearchInput]="true"></app-options-card>
      <app-card title="Filter By Phone Number" [collapsed]="false">
        <app-mat-phone-number-input [(ngModel)]="filterFromNumber" label="From Number"
                                    [useNationalInput]="true"
                                    [ngModelOptions]="{standalone: true}"></app-mat-phone-number-input>

        <app-mat-phone-number-input [(ngModel)]="filterToNumber" label="To Number"
                                    [useNationalInput]="true"
                                    [ngModelOptions]="{standalone: true}"></app-mat-phone-number-input>
      </app-card>
      <app-options-card title="Filter By Status" [options]="filterByStatusOptions"
                        [(checkedOptions)]="checkedStatusOptions"></app-options-card>
      <app-options-card title="Filter By Type" [options]="filterByTypeOptions"
                        [(checkedOptions)]="checkedTypeOptions"></app-options-card>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="closeSendConfirmPopup('proceed')">Filter</button>
  </mat-dialog-actions>
</div>
